export default __webpack_public_path__ + "static/media/s.64b05173.png";